import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { InvoiceNotificationsService, InvoiceNotification } from 'src/app/service/invoice-notifications.service';

@Component({
  selector: 'app-invoice-notifications',
  templateUrl: './invoice-notifications.component.html',
  styleUrls: ['./invoice-notifications.component.scss']
})
export class InvoiceNotificationsComponent implements OnInit, OnDestroy {
  private readonly ngDestroy$ = new Subject();

  notifications$: Observable<InvoiceNotification[]>

  constructor(private invoiceNotificationsService: InvoiceNotificationsService) {

  }

  ngOnInit(): void {
    this.notifications$ = this.invoiceNotificationsService.get()
  }

  ngOnDestroy() {
    this.ngDestroy$.next(undefined);
    this.ngDestroy$.complete();
  }
}
